import { FC } from "react";
export const DashboardIcon: FC<{ className?: string }> = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.61111 0H8.27778C8.88889 0 9.38889 0.5 9.38889 1.11111V7.77778C9.38889 8.38889 8.88889 8.88889 8.27778 8.88889H1.61111C1 8.88889 0.5 8.38889 0.5 7.77778V1.11111C0.5 0.5 1 0 1.61111 0ZM12.7222 0H19.3889C20 0 20.5 0.5 20.5 1.11111V7.77778C20.5 8.38889 20 8.88889 19.3889 8.88889H12.7222C12.1111 8.88889 11.6111 8.38889 11.6111 7.77778V1.11111C11.6111 0.5 12.1111 0 12.7222 0ZM1.61111 11.1111H8.27778C8.88889 11.1111 9.38889 11.6111 9.38889 12.2222V18.8889C9.38889 19.5 8.88889 20 8.27778 20H1.61111C1 20 0.5 19.5 0.5 18.8889V12.2222C0.5 11.6111 1 11.1111 1.61111 11.1111ZM16.0556 11.1111C15.4444 11.1111 14.9444 11.6111 14.9444 12.2222V14.4444H12.7222C12.1111 14.4444 11.6111 14.9444 11.6111 15.5556C11.6111 16.1667 12.1111 16.6667 12.7222 16.6667H14.9444V18.8889C14.9444 19.5 15.4444 20 16.0556 20C16.6667 20 17.1667 19.5 17.1667 18.8889V16.6667H19.3889C20 16.6667 20.5 16.1667 20.5 15.5556C20.5 14.9444 20 14.4444 19.3889 14.4444H17.1667V12.2222C17.1667 11.6111 16.6667 11.1111 16.0556 11.1111Z"
        fill="white"
      />
    </svg>
  );
};
